
// import {Loading} from 'element-ui'
import UserInfo from "@/mobileComponents/UserInfo";

export default {
  name: "MyStuff",
  data() {
    return {
      // 我的套餐列表
      myStuffList: [],
      // 我的套餐总数量
      total: 0,
      // 当前页面
      currentPage: 1,
      // 每页显示的套餐个数
      pageSize: 3,
      showError: false,
    };
  },
  components: {
    UserInfo,
  },
  created() {
    this.getMyStuff();
    // this.loading.close()
  },
  methods: {
    // 返回
    onClickLeft() {
      this.$router.back()
    },
    // 获取我的套餐
    async getMyStuff() {
      try {
        const { data } = await this.$http.post("/shop/purchased", {
          page: this.currentPage,
          eachpage: this.pageSize,
        });
        if (data.status === "success") {
          this.myStuffList = data.data
          this.total = data.total
        } else {
        }
      } catch (err) {
        this.$notify({ type: "danger", message: "网络异常,请稍后再试" });
      }
      if (this.myStuffList.length === 0) {
        this.showError = true;
      }
    },
    //  取消自动续费
    async cancelCost (row) {
      // let noticeText = row.automatic_renewal == 0 ? '确定开启自动续费吗?' : '确定取消自动续费吗?'
      // this.$dialog.confirm({
      //   title: '提示',
      //   message: noticeText
      // }).then(async () => {
        try {
          const { data } = await this.$http.post('/shop/automaticrenewal', { id: row.id })
          if (data.status == 'success') {
            this.myStuffList.forEach(item => {
              if (item.id == row.id) {
                item.automatic_renewal == 1 ? item.automatic_renewal = 0 : item.automatic_renewal = 1
              }
            })
            this.$notify({type:'success',message:data.msg})
          } else {
            this.$notify({type:'danger',message:data.msg})
          }
        } catch (err) {
          this.$notify({type:'danger',message:'网络异常,请稍后再试'})
        }
      // }).catch(() => {
      // })
    },
    // 退订套餐
    async unSubscribe(id) {
      let row = this.myStuffList.filter((item) => {
        return item.id === id;
      });
      row = row[0];
      try {
        const { data } = await this.$http.post("/shop/refund_amount", {
          id: id,
        });
        if (data.status !== "success") {
          return this.$notify({ type: "danger", message: data.msg });
        }
        let refund_amount = data.data.refund_amount.toFixed(4);
        this.$dialog
          .confirm({
            message: `确定退订套餐 <span style="color: #495a7c;">${row.name}</span> ?
            <br>当前套餐预计可退: <span style="color: #F56C6C;">${refund_amount}</span> 元`,
            title: "提示",
          })
          .then(async () => {
            const { data } = await this.$http.post("/shop/unsubscribe", { id });
            if (data.status === "success") {
              this.getMyStuff();
              let money =
                parseFloat(refund_amount) + parseFloat(this.$store.state.money);
              this.$store.commit("setOther", {
                name: "money",
                value: money,
              });
              this.myStuffList.forEach((item) => {
                if (item.id === id) {
                  this.$store.commit("setOther", {
                    name: "package_purchased_monitor",
                    value:
                      this.$store.state.package_purchased_monitor -
                      item.monitor,
                  });
                  this.$store.commit("setOther", {
                    name: "point",
                    value: this.$store.state.point - item.point,
                  });
                }
              });
              this.$notify({ type: "success", message: data.msg });
            } else {
              this.$notify({ type: "danger", message: data.msg });
            }
          }).catch((e) => {})
      } catch (e) {
        this.$notify({ type: "danger", message: "网络异常,请稍后再试" });
      }
    },
  },
};
